/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentResultResponseDataModel {
    getFixupPrototypeFunction() { return AssessmentResultResponseDataModel.fixupPrototype; }

    static newInstance(model: Partial<AssessmentResultResponseDataModel>): AssessmentResultResponseDataModel {
        let obj = Object.assign(new AssessmentResultResponseDataModel(), model);
        AssessmentResultResponseDataModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentResultResponseDataModel>): AssessmentResultResponseDataModel {
        if (!model) return null;
        return AssessmentResultResponseDataModel.newInstance(<AssessmentResultResponseDataModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentResultResponseDataModel) {
        if (!obj) return;

        models.AssessmentResultResponseDataModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentResultResponseDataModel): boolean {
        Object.setPrototypeOf(obj, AssessmentResultResponseDataModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Overall assessment status for the cloud account
     */
    overall_status: string;

    /**
     * Assessment score for the cloud account
     */
    score: string;

    /**
     * Grade based on the assessment for the cloud account
     */
    grade: string;

    /**
     * Last assessed time for the cloud account
     */
    last_assessed_time: string;

    /**
     * Summary of the assessment for the cloud account on OSCAR
     */
    summary: any;

    /**
     * History of the assessment for the cloud account on OSCAR
     */
    history: any;

}
